<template>
  <el-dialog
    title="绑定手机号"
    :visible.sync="dialogVisible"
    width="500px"
    :close-on-click-modal="false"
    :show-close="false"
    :close-on-press-escape="false"
    class="bind-phone-dialog"
  >
    <div class="bind-content">
      <p class="tips">为了账号安全，请绑定手机号</p>
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="手机号码" prop="mobile">
          <el-input
            v-model="form.mobile"
            placeholder="请输入手机号码"
            @blur="validateMobile"
            @input="handleMobileChange"
          />
        </el-form-item>

        <el-form-item label="验证码" prop="captcha" v-if="showCaptcha">
          <div class="captcha-wrapper">
            <el-input
              v-model="form.captcha"
              placeholder="请输入验证码"
              maxlength="6"
            />
            <el-button
              :disabled="!isMobileValid || isCooling"
              @click="getCaptcha"
              class="captcha-btn"
            >
              {{ isCooling ? `${countdown}s` : '获取验证码' }}
            </el-button>
          </div>
        </el-form-item>

        <el-form-item v-if="mobileError" class="error-item">
          <span class="mobile-error">{{ mobileError }}</span>
        </el-form-item>
      </el-form>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handleLogout">退出登录</el-button>
      <el-button type="primary" @click="submitForm" :loading="submitting">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sendCodeToPhoneApi } from '@/api/account'
import { updateUserInfoApi } from '@/api/user'
import { mapState } from 'vuex'

export default {
  name: 'BindPhoneDialog',
  data() {
    return {
      form: {
        mobile: '',
        captcha: ''
      },
      mobileError: '',
      isMobileValid: false,
      showCaptcha: false,
      isCooling: false,
      countdown: 0,
      timer: null,
      submitting: false,
      rules: {
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        captcha: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { pattern: /^\d{6}$/, message: '验证码为6位数字', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
      token: state => state.token,
      needBindPhone: state => state.needBindPhone
    }),
    dialogVisible: {
      get() {
        return this.needBindPhone
      },
      set(val) {
        this.$store.commit('SET_NEED_BIND_PHONE', val)
      }
    }
  },
  watch: {
    userInfo: {
      handler(val) {
        if (val && val.mobile) {
          this.dialogVisible = false
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    validateMobile() {
      const mobile = this.form.mobile.trim()
      if (!mobile) {
        this.mobileError = '手机号不能为空'
        this.isMobileValid = false
        return false
      }
      const reg = /^1[3-9]\d{9}$/
      if (!reg.test(mobile)) {
        this.mobileError = '请输入正确的手机号码'
        this.isMobileValid = false
        return false
      }
      this.mobileError = ''
      this.isMobileValid = true
      return true
    },
    handleMobileChange() {
      const currentMobile = this.userInfo?.mobile || ''
      this.showCaptcha = this.form.mobile !== currentMobile
      this.validateMobile()
    },
    async getCaptcha() {
      if (!this.validateMobile()) return
      this.$message.info('正在发送验证码...')
      try {
        await sendCodeToPhoneApi(this.form.mobile)
        this.$message.success('验证码发送成功')
        this.isCooling = true
        this.startCountdown()
      } catch (error) {
        this.$message.error('发送失败，请稍后重试')
      }
    },
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        this.countdown--
        if (this.countdown <= 0) {
          this.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
      this.isCooling = false
      this.countdown = 0
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.submitting = true
        try {
          const updateData = {
            ...this.userInfo,
            mobile: this.form.mobile,
            code: this.form.captcha
          }
          const res = await updateUserInfoApi(updateData)
          if (res.errno === 0) {
            this.$message.success('绑定成功')
            await this.$store.dispatch('getUserInfo')
          } else {
            this.$message.error(res.errmsg || '绑定失败')
          }
        } catch (error) {
          this.$message.error(error.errmsg || '绑定失败，请重试')
        } finally {
          this.submitting = false
        }
      })
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('logOut').then(() => {
          this.$router.replace('/login')
        })
      }).catch(() => {})
    }
  },
  beforeDestroy() {
    this.stopCountdown()
  }
}
</script>

<style scoped lang="scss">
.bind-phone-dialog {
  .bind-content {
    padding: 20px;
    .tips {
      text-align: center;
      color: #f56c6c;
      margin-bottom: 20px;
    }
    .captcha-wrapper {
      display: flex;
      gap: 10px;
      .captcha-btn {
        min-width: 120px;
      }
    }
    .mobile-error {
      color: #f56c6c;
      font-size: 12px;
    }
  }
  .dialog-footer {
    display: flex;
    justify-content: space-between;
    button {
      width: 45%;
    }
  }
}
</style>
